import { useState } from "react";
import InputField from "../Input-field/input-field.component";
import { ReactComponent as EyeIcon } from "../../icons/eye-icon.svg";
import { ReactComponent as CloseEyeIcon } from "../../icons/close-eye-icon.svg";
import { CMInputPassword } from "./input-password.styles";
import { CMErrorMessage } from "../Input-field/input-field.styles";

const InputPassword = (props) => {
    const [inputType, setInputType] = useState('password');

    const handleShowPass = () => setInputType(old => old === 'password' ? 'text' : 'password');

    return (
        <>
        <CMInputPassword>
            <InputField {...props} type={inputType} password={true}/>
            <span onClick={handleShowPass}>
                {inputType === 'password' ?
                    <EyeIcon width={24} height={24}/>
                :   <CloseEyeIcon width={24} height={24}/>
                }
            </span>
        </CMInputPassword>
            {inputType === 'password' ?
                <CMErrorMessage variant="caption" name={props?.name} style={{position: "relative",top: "-19px", }}>
                    {props?.error}
                </CMErrorMessage> :
                ""
            }
        </>
    );
}

export default InputPassword;